import { render, staticRenderFns } from "./groupBox.vue?vue&type=template&id=65d95031&scoped=true&"
import script from "./groupBox.vue?vue&type=script&lang=js&"
export * from "./groupBox.vue?vue&type=script&lang=js&"
import style0 from "./groupBox.vue?vue&type=style&index=0&id=65d95031&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d95031",
  null
  
)

export default component.exports